import { useContext, useState } from 'react'
import LinkWithStatus from '../common/LinkWithStatus'
import { NavContext } from '../../context/global_context'
import { getRequest, postRequest } from '../../services/base'
import LoadingSpinnerOverlay from '../common/LoadingSpinnerOverlay'
import { useParams } from 'react-router-dom'
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../common/Modal'
import CheckBox from '../common/CheckBox'
import InputText from '../common/InputText'
import Button from '../common/Button'
import NoRecordsFound from '../common/NoRecordsFound'
import Tooltip from '../common/tooltip'
import { formatEmptyValue } from '../../utils/common'

const GenerateWiresButton = ({
  is_inspection_points_wire = false,
  is_power_distribution_wire = false,
}) => {
  const { vehicle } = useParams()
  const [navState, navDispatch] = useContext(NavContext)

  const [generateWireButtonStatus, setGenerateWireButtonStatus] =
    useState(false)
  const [showHarnesses, setShowHarnesses] = useState(false)
  const [harnesses, setHarnesses] = useState({})
  const [filteredHarnesses, setFilteredHarnesses] = useState([])
  const [selectedHarnesses, setSelectedHarnesses] = useState([])

  const getHarnessList = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Harnesses...',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/harnesses/harness_names/list/?vehicle=${vehicle}&is_inspection_points_wire=${is_inspection_points_wire}&is_power_distribution_wire=${is_power_distribution_wire}`
    )
    if (res?.status) {
      setHarnesses(res.data)
      setFilteredHarnesses(Object.keys(res.data))
    } else {
      setHarnesses({})
      setFilteredHarnesses([])
    }

    navDispatch({
      type: 'loader',
      data: {
        caption: '',
        showLoader: false,
      },
      notification: {},
    })
  }

  const onGenerateWiresClick = async (connectors = []) => {
    setShowHarnesses(true)
    getHarnessList()
  }

  const generateWires = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Processing wire generation',
        showLoader: true,
      },
      notification: {},
    })

    let res = await postRequest(`/api/wire/generate_wires/`, {
      vehicle: vehicle,
      connectors: [],
      clean_wires: false,
      is_inspection_points_wire: is_inspection_points_wire,
      is_power_distribution_wire: is_power_distribution_wire,
      harnesses: selectedHarnesses,
    })
    navDispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: 'Wire Generation successfully started',
      },
    })
    resetGenerateWiresButtonState()
    getGenerateWireButtonStatus()
  }

  const getGenerateWireButtonStatus = async () => {
    let response = await getRequest(
      `/api/dtcs/generate_wire_button_status/?vehicle=${vehicle}`
    )
    setGenerateWireButtonStatus(response.show_loader)
    if (response.show_loader) {
      setTimeout(() => {
        getGenerateWireButtonStatus()
      }, 7000)
    }
  }

  const resetGenerateWiresButtonState = () => {
    setShowHarnesses(false)
    setHarnesses({})
    setFilteredHarnesses([])
  }
  return (
    <>
      <Modal
        onClose={() => {
          resetGenerateWiresButtonState()
        }}
        show={showHarnesses}
      >
        <ModalHeader className={'text-white'}>
          Select Harnesses To Generate Wires
        </ModalHeader>
        <ModalBody>
          <div className="flex items-center w-full">
            <InputText
              name="search_value"
              placeholder={`Search Harnesses`}
              className={`w-100`}
              isFullSize={true}
              type="search"
              onChange={(value) => {
                setFilteredHarnesses(
                  Object.keys(harnesses).filter((harness) =>
                    harness
                      .toLocaleLowerCase()
                      .includes(value.toLocaleLowerCase())
                  )
                )
              }}
              isRequired={false}
              wrapperClass={`py-2 px-0`}
            />
          </div>
          {filteredHarnesses?.map((harness, harnessIndex) => {
            return (
              <div
                className="flex flex-col flex-grow items-center bg-white w-full px-2 py-1 border-b border-tracer-dark-blue cursor-pointer group hover:bg-blue-100"
                key={`harness-${harnessIndex}-${harness}`}
              >
                <div className="flex flex-row flex-grow items-center w-full cursor-pointer group">
                  <div>
                    <CheckBox
                      checked={selectedHarnesses.includes(harness)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          let tempArray = [...selectedHarnesses]
                          tempArray.push(harness)
                          setSelectedHarnesses(tempArray)
                        } else {
                          let tempArray = [...selectedHarnesses].filter(
                            function (element) {
                              return element !== harness
                            }
                          )
                          setSelectedHarnesses(tempArray)
                        }
                      }}
                    />
                  </div>
                  <div className="w-full pl-2 flex flex-row flex-grow items-center w-full">
                    <div className="w-full text-sm table_text">
                      <div className="font-bold"> {harness}</div>
                      <Tooltip message={harnesses[harness].join(' , ')}>
                        {formatEmptyValue(harnesses[harness].join(' , '))}
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
          {filteredHarnesses?.length < 1 && (
            <NoRecordsFound caption="Harnesses Not Found" />
          )}
        </ModalBody>
        <ModalFooter className={'text-white'}>
          <div className="flex py-2 justify-end">
            <Button
              className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded ${selectedHarnesses?.length < 1 && 'disabled'}`}
              onClick={(e) => {
                e.preventDefault()
                generateWires()
              }}
              text="Generate Wires"
              key={`generate-wire-btn`}
            />
          </div>
        </ModalFooter>
      </Modal>

      <LoadingSpinnerOverlay active={generateWireButtonStatus} />

      <LinkWithStatus
        href={`/vehicles/generate_wires`}
        className={
          'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
        }
        title="Generate Wires"
        onClickFunc={(e) => {
          onGenerateWiresClick([])
        }}
        key={`generate-all-wire-btn`}
      />
    </>
  )
}

export default GenerateWiresButton
